export enum AppointmentSuggestionSearchType {
  Normal = 'normal',
  Overlapping = 'overlapping',
  NoPractitioner = 'noPractitioner',
}
